import { hasCapability, type User } from "../base";

export const county = {
  update: (user: User) => hasCapability(user, "county.update"),
  create: (user: User) => hasCapability(user, "county.create"),
  read: (user: User) => hasCapability(user, "county.read"),
};
